import { iStripeCard, iStripeToken } from "@/interfaces/payments";
import { StripeService } from "@/services/stripe";

export interface iStripeService {
  /**
   * Generates a new stripe card token.
   *
   * @param {iStripeCard} card
   * @returns {Promise<iStripeToken>}
   */
  generateCardToken(card: iStripeCard): Promise<iStripeToken>;
}

/**
 * Bit hacky but works for now.
 * This makes a new stripe service that uses the stripe token defined on the window object.
 *
 * @returns {null | iStripeService}
 */
export const makeStripeService = () =>
  window.stripeKey ? new StripeService(window.stripeKey) : null;
